import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-flex;
`;

const Image = styled.img`
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
`;

const Logo = ({ image }) => (
  <Wrapper>
    <Image src={image} alt="logo" />
  </Wrapper>
);

export default Logo;
